module.exports = __webpack_public_path__ + "img/底部云.6e573328.png";